import { combineReducers, Reducer } from 'redux'
import appReducer, { IAppStore } from './appReducer'
import gameReducer, { IGameStore } from './gameReducer'
import qsReducer, { IQSStore } from './qsReducer'
import previewReducer from './previewReducer'
import accessibilityReducer, { IAccessibilityStore } from './accessibilityReducer'

export interface IStore {
	app: IAppStore
	game: IGameStore
	qs: IQSStore
	preview: any
	accessibility: IAccessibilityStore
}

const AppReducer: Reducer<IStore> = combineReducers({
	app: appReducer,
	game: gameReducer,
	qs: qsReducer,
	preview: previewReducer,
	accessibility: accessibilityReducer,
})

export default AppReducer
